module.exports = __webpack_public_path__ + "img/dark-mode-gradient.d2f24ac5.svg";